import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function SimpleFooter() {
  return (
    <footer className="bg-slate-950 text-slate-400 py-14" data-testid="landing-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-5 flex-wrap">
              <Logo variant="navy" size={140} textColor="text-white" subColor="text-slate-400" />
              {/* Siaq secondary identity — «إحدى منصات سياق». Sits next to Emad logo. */}
              <div
                className="flex items-center gap-3 ps-5 border-s border-slate-700/70"
                data-testid="siaq-badge-landing"
              >
                <img
                  src={require("@/assets/siaq-logo.png")}
                  alt="شركة سياق"
                  className="h-16 w-auto object-contain select-none pointer-events-none opacity-95"
                  draggable={false}
                />
                <span className="text-xs text-slate-400 font-medium tracking-wide leading-tight">
                  إحدى منتجات
                  <br />
                  سياق
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed mt-4 max-w-md">
              رحلة تأهيل تربط الطلاب بفرص التدريب التعاوني، من فرصة التدريب التعاوني إلى شهادة الإنجاز الموثقة.
            </p>
          </div>
          <div>
            <div className="text-white font-heading font-bold mb-4">الروابط</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/opportunities" className="hover:text-white transition-colors">فرص التدريب التعاوني</Link></li>
              <li><Link to="/partners" className="hover:text-white transition-colors">انضم لشركاء عماد</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">الأسئلة الشائعة</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">تواصل معنا</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-white font-heading font-bold mb-4">تواصل</div>
            <ul className="space-y-2 text-sm">
              <li dir="ltr">emad-os@siaq-sa.com</li>
              <li>مكة المكرمة، المملكة العربية السعودية</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-3 text-xs">
          <div>© {new Date().getFullYear()} عماد. جميع الحقوق محفوظة.</div>
          <div className="flex gap-5">
            <Link to="/terms" className="hover:text-white transition-colors">الشروط والأحكام</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">سياسة الخصوصية</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
